import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidates|Exam Events|';
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'portal' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	portal: 'SP',
	feature: HubFeature.Exam,
};

export type ExamEventsLoc =
	| 'SPExamEventsLabelId'
	| 'SPExamEventsLabelExamName'
	| 'SPExamEventsLabelAppointmentDate'
	| 'SPExamEventsLabelEvent'
	| 'SPExamEventsLabelDataProvider'
	| 'SPExamEventsLabelRegistration'
	| 'SPExamEventsLabelAuthorization'
	| 'SPExamEventsLabelVoucher'
	| 'SPExamEventsLabelLastUpdated'
	| 'SPExamEventsLabelExternalId'
	| 'SPExamEventsSectionTitle'
	| 'SPExamEventsSectionDescription'
	| 'SPExamEventsLabelDiscount'
	| 'SPExamEventsLabelVoucherNumber';

export const examEventsLocs: LocDefs<ExamEventsLoc> = {
	SPExamEventsLabelId: {
		defaultValue: 'ID',
		displayType: 'Label',
		description: 'Column heading for ID column in exam events table',
		displayPath: `${dpRoot}ID`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.ID',
		...sharedProps,
	},
	SPExamEventsLabelExamName: {
		defaultValue: 'Exam Name',
		displayType: 'Label',
		description: 'Column heading for Exam Name column in exam events table',
		displayPath: `${dpRoot}Exam Name`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.ExamName',
		...sharedProps,
	},
	SPExamEventsLabelAppointmentDate: {
		defaultValue: 'Appointment Date',
		displayType: 'Label',
		description: 'Column heading for Appointment Date column in exam events table',
		displayPath: `${dpRoot}Appointment Date`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.AppointmentDate',
		...sharedProps,
	},
	SPExamEventsLabelEvent: {
		defaultValue: 'Event',
		displayType: 'Label',
		description: 'Column heading for Event column in exam events table',
		displayPath: `${dpRoot}Event`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.Event',
		...sharedProps,
	},
	SPExamEventsLabelDataProvider: {
		defaultValue: 'Data Provider',
		displayType: 'Label',
		description: 'Column heading for Data Provider Name column in exam events table',
		displayPath: `${dpRoot}Data Provider Name`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.DataProviderName',
		...sharedProps,
	},
	SPExamEventsLabelRegistration: {
		defaultValue: 'Registration',
		displayType: 'Label',
		description: 'Column heading for Registration Number column in exam events table',
		displayPath: `${dpRoot}Registration Number`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.RegistrationNumber',
		...sharedProps,
	},
	SPExamEventsLabelAuthorization: {
		defaultValue: 'Authorization',
		displayType: 'Label',
		description: 'Column heading for Authorization column in exam events table',
		displayPath: `${dpRoot}Authorization`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.Authorization',
		...sharedProps,
	},
	SPExamEventsLabelVoucher: {
		defaultValue: 'Voucher',
		displayType: 'Label',
		description: 'Column heading for Voucher column in the exam events table.',
		displayPath: `${dpRoot}Voucher`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.Voucher',
		...sharedProps,
	},
	SPExamEventsLabelLastUpdated: {
		defaultValue: 'Last Update',
		displayType: 'Label',
		description: 'Column heading for Last Updated column in exam events table',
		displayPath: `${dpRoot}Last Updated`,
		legacyName: 'Exam/Candidates.ExamEvents.ColumnHeading.Updated',
		...sharedProps,
	},
	SPExamEventsLabelExternalId: {
		defaultValue: 'Exam Code',
		displayType: 'Label',
		description: 'Column heading for External ID column in exam events table',
		displayPath: `${dpRoot}External ID`,
		...sharedProps,
	},
	SPExamEventsSectionTitle: {
		defaultValue: 'Exam Events',
		displayType: 'Title',
		description: 'Page title for exam event history of the candidate',
		displayPath: `${dpRoot}Section Title`,
		legacyName: 'Exam/Candidates.ExamEvents.Title.PageSectionTitle',
		...sharedProps,
	},
	SPExamEventsSectionDescription: {
		defaultValue: '',
		displayType: 'Content',
		description: 'Section description for exam events page',
		displayPath: `${dpRoot}Section Description`,
		...sharedProps,
		htmlAllowed: true,
	},
	SPExamEventsLabelDiscount: {
		defaultValue: 'Discount',
		displayType: 'Label',
		description: 'Column heading for Discount column in exam events table',
		displayPath: `${dpRoot}Discount`,
		...sharedProps,
	},
	SPExamEventsLabelVoucherNumber: {
		defaultValue: 'Voucher',
		displayType: 'Label',
		description: 'Column heading for Voucher Number column in exam events table',
		displayPath: `${dpRoot}Voucher Number`,
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<ExamEventsLoc>(examEventsLocs);
